import React, { Component } from 'react';

import Modal from './Modal';

class ModalComponent extends Component {
	show() {
		this.comp.getWrappedInstance().show();
	}

	hide() {
		this.comp.getWrappedInstance().hide();
	}

	render() {
		return <Modal ref={c => (this.comp = c)} {...this.props} />;
	}
}

export default ModalComponent;

export { default as Dismiss } from './Dismiss';
